import { CalendarOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import CIQDatePicker from "components/custom-date-picker";
import type { Dayjs } from "dayjs";
import { useState, useImperativeHandle, forwardRef } from "react";

type Props = {
  value?: Dayjs | null;
  disabled?: boolean;
  onChange: (value: Dayjs | null, dateString: string | null) => void;
  disabledDate?: (current: Dayjs) => boolean;
  renderExtraFooter?: (mode: any) => React.ReactNode;
  title?: string;
  icon?: React.ReactNode;
};

const DatePickerWithIcon = forwardRef((props: Props, ref: any) => {
  const {
    value,
    disabled = false,
    onChange,
    disabledDate,
    renderExtraFooter,
    title,
    icon = <CalendarOutlined />
  } = props;

  const [openDatePicker, setOpenDatePicker] = useState(false);
  useImperativeHandle(ref, () => ({
    close() {
      setOpenDatePicker(false);
    }
  }));

  return (
    <div>
      <Tooltip title={title}>
        <Button
          disabled={disabled}
          className="hover:!text-ciq-primary-800 hover:!bg-ciq-primary-800 hover:!bg-opacity-5"
          style={{
            fontSize: "inherit",
            padding: 0,
            margin: 0,
            border: "none",
            width: 20,
            height: 20,
            color: "var(--ciq-primary-900)",
            background: "transparent"
          }}
          icon={icon}
          onClick={() => {
            setOpenDatePicker(true);
          }}
          data-testid="datepickerwithicon-button"
        />
      </Tooltip>
      <CIQDatePicker
        className="h-0 w-0 p-0 m-0 border-0 border-none bg-white ciq-date-picker"
        allowClear={false}
        open={openDatePicker}
        onOpenChange={() => setOpenDatePicker(false)}
        value={value}
        onChange={onChange}
        disabledDate={disabledDate}
        renderExtraFooter={renderExtraFooter}
        showToday={false}
      />
    </div>
  );
});
DatePickerWithIcon.displayName = "DatePickerWithIcon";
export default DatePickerWithIcon;
